import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { EmailTemplate } from "@types";
import { App } from "antd";

export const useResetEmailTemplate = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const resetEmailTemplate = async (emailTemplate: EmailTemplate) => {
    try {
      const response = await axios.post<EmailTemplate>("/api/emailtemplates/reset", emailTemplate);
      return response.data;
    } catch (error) {
      throw new Error(t("messages.error.resetEmailTemplate"));
    }
  };

  return useMutation({
    mutationFn: resetEmailTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      message.success(t("messages.success.resetEmailTemplate"));
    },
  });
};